import { Product } from '@commerce/types'
import { getIdFromGraphQlId } from '@lib/general'
import { eventLog, EVENT_DEBUG, infoLog, loginStatus } from './general'

declare global {
  interface Window {
    dataLayer: any
  }
}

export const productDetailsViewEvent = (product: Product.Product) => {
  if (EVENT_DEBUG && !window?.dataLayer) {
    infoLog('ProductDetailsView: No Data Layer found.')
  }

  let logEventName = 'productDetailsView (custom)'

  if (window?.dataLayer) {
    const detail = {
      event: 'detailView',
      ecommerceEventLabel: product?.name,
      google_tag_params: {
        ecomm_pagetype: 'product',
        ecomm_prodid: getIdFromGraphQlId(product.id, 'gid://shopify/Product/'),
        ecomm_totalvalue: product.price?.value,
      },
      ecommerce: {
        currencyCode: product?.price.currencyCode,
        detail: {
          products: [
            {
              name: product?.name,
              id: getIdFromGraphQlId(product.id, 'gid://shopify/Product/'),
              brand: product?.vendor,
              price: product.price?.value,
            },
          ],
        },
      },
      ...loginStatus(),
    }

    window?.dataLayer?.push(detail)
    if (EVENT_DEBUG)
      eventLog(`Product Page test 'gtm.ecommerce.${logEventName}`, { detail })
  }
}
